import {DEFAULT_RETARDER_VALUE} from '../../../fields/retarder/retarder.constants'
import {RetarderConfiguration, RetarderForm} from '../../../fields/retarder/types'
import {CreateFormInput} from '../types'

export const buildRetarderForm = ({
  configuration: {retarder}
}: CreateFormInput<RetarderConfiguration>): RetarderForm => {
  return {
    retarder: retarder.isEnabled
      ? {
          retarder: DEFAULT_RETARDER_VALUE,
          retarderUom: retarder.uom
        }
      : undefined
  }
}
